// Hand-rolled icons to stay on-brand: 1.5px strokes, slightly geometric.
// All accept { size, className } props.

const baseProps = (size = 16) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
});

export const IconMonitor = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <rect x="3" y="4" width="18" height="13" rx="1.5" />
    <path d="M8 21h8M12 17v4" />
  </svg>
);

export const IconUsers = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20" />
    <circle cx="10" cy="8" r="3.5" />
    <path d="M20 20v-1.5a3.5 3.5 0 0 0-2.5-3.35" />
    <path d="M15 4.5a3.5 3.5 0 0 1 0 7" />
  </svg>
);

export const IconShield = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M12 3 4 6v5c0 4.5 3.4 8.5 8 10 4.6-1.5 8-5.5 8-10V6l-8-3Z" />
  </svg>
);

export const IconSettings = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
  </svg>
);

export const IconLayers = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="m12 2 10 5-10 5L2 7l10-5Z" />
    <path d="m2 12 10 5 10-5" />
    <path d="m2 17 10 5 10-5" />
  </svg>
);

export const IconActivity = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M22 12h-4l-3 9-6-18-3 9H2" />
  </svg>
);

export const IconCreditCard = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M2 10h20M6 15h4" />
  </svg>
);

export const IconSearch = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

export const IconCheck = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="m5 12 5 5L20 7" />
  </svg>
);

export const IconX = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const IconArrow = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </svg>
);

export const IconPlay = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <path d="M7 4v16l13-8z" />
  </svg>
);

export const IconDot = (p) => (
  <svg {...baseProps(p.size)} className={p.className}>
    <circle cx="12" cy="12" r="4" fill="currentColor" />
  </svg>
);
